<template>
  <div
    ref="modal"
    class="modal fade"
    role="dialog"
    :aria-label="lastActiveModalDialog?.title"
    data-bs-backdrop="static"
  >
    <div
      ref="content"
      class="modal-dialog w-100"
      :class="{ 'modal-lg' : lastActiveModalDialog?.isWide }"
    >
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { OpenedDialog } from '@/Types/modalDialogContextData';
  import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
  import useBootstrapApi from '@/VueCore/utils/useBootstrapApi';
  import { computed, onMounted, ref, watch } from 'vue';

  const contextData = useContextDataStore();
  const modal = ref<HTMLElement>();
  const content = ref<HTMLElement>();

  onMounted(() => {
    contextData.modal.elements.root = modal.value!;
    contextData.modal.elements.content = content.value!;
  });

  const bsModal = useBootstrapApi(bootstrap => {
    return bootstrap.Modal.getOrCreateInstance(modal.value!)
  });

  watch(() => contextData.modal.openedDialogs.length, val => {
    if (val) {
      bsModal.value?.show();
    } else {
      bsModal.value?.hide();
    }
  });

  // We want to remember the last active dialog state to prevent modal dialog size changing
  // during bootstrap hiding animation.
  const lastActiveModalDialog = computed<OpenedDialog | undefined>(previousValue => {
    return contextData.activeModalDialog ?? previousValue;
  });
</script>